// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const poipole: PokeData = {
  "id": 803,
  "name": "poipole",
  "height": 6,
  "weight": 18,
  "base_experience": 189,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "fury-attack",
    "growl",
    "acid",
    "peck",
    "toxic",
    "charm",
    "helping-hand",
    "gastro-acid",
    "poison-jab",
    "dragon-pulse",
    "nasty-plot",
    "venoshock",
    "fell-stinger",
    "venom-drench"
  ],
  "moves": [
    "growl",
    "acid",
    "peck",
    "poison-jab",
    "dragon-pulse",
    "venom-drench",
    "toxic-overload",
    "poison-powder",
    "mortal-gas",
    "poison-fang",
    "toxic-spikes",
    "poison-gas",
    "sludge-bomb"
  ],
  "evolution_chain": {
    "id": 424,
    "item": null,
    "species": [
      {
        "name": "poipole",
        "order": 803,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "naganadel",
        "order": 804,
        "types": [
          PokeType.POISON,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 803,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "dragon-pulse"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67,
    "speed": 73,
    "ability_power": 73
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
